import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { openURIInApp } from '../../utils/URLSchemeHelper'

const AnnouncementDetail = ({ announcement, fetchAnnouncement }) => {
  useEffect(() => {
    fetchAnnouncement()
  }, [fetchAnnouncement])

  if(!announcement) {
    return null
  }

  return (
    <div className="d-Tickerdetail">
      <h1 className="d-Tickerdetail-title">{announcement.title}</h1>
      <div className="d-Tickerdetail-content">
        {announcement.image_url && <img src={announcement.image_url} alt="" />}
        {(announcement.details || '').split(/\n/).map((line, i) => <p key={i}>{line}</p>)}

        {announcement.link_url &&
          <a onClick={() => openURIInApp(announcement.link_url, 'INFO_DETAIL', 'OPEN_URL')}>{announcement.link_label}</a>
        }
      </div>
    </div>
  )
}

AnnouncementDetail.propTypes = {
  announcement: PropTypes.object,
  fetchAnnouncement: PropTypes.func.isRequired,
}

export default AnnouncementDetail
